var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"app":"","absolute":"","inset":"","color":"primary white--text"}},[_c('span',[_vm._v(" © "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v("راديو زوارة")])])])}
var staticRenderFns = []

export { render, staticRenderFns }